import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { BreadcrumbRowComponent } from './breadcrumb-row.component';

// Pulled out of HomeModule into its own module so components outside
// HomeModule (e.g. lazy-loaded feature modules) can still use
// <app-breadcrumb-row>. HomeModule now imports this module instead of
// declaring the component itself — see the home.module.ts changes.
//
// NOTE: I don't have breadcrumb-row.component.ts/html, so RouterModule +
// TranslateModule are included as a reasonable default for a breadcrumb
// (router links + translated labels). If the component doesn't actually
// use one of these, it's harmless to leave imported — but if it needs
// something else (e.g. a PrimeNG module), add that import here too.
@NgModule({
  declarations: [BreadcrumbRowComponent],
  imports: [CommonModule, RouterModule, TranslateModule],
  exports: [BreadcrumbRowComponent],
})
export class BreadcrumbRowModule {}
